import request from "@/router/axios";
export const all = () => {
  return request({
    url: `/api/jc/resource/list`,
    method: "post",
    data: {
      filterParams: [{ name: "isValid", value: true }],
      orderBy: "code",
      isDesc: false,
    },
  });
};
export const add = (data) => {
  return request({
    url: `/api/jc/resource/add`,
    method: "post",
    data,
  });
};
export const setTemplate = (ids, templateId) => {
  return request({
    url: `/api/jc/resource/setTemplate`,
    method: "post",
    params: {
      ids,
      templateId,
    },
  });
};
export const buildPlan = (resId) => {
  return request({
    url: `/api/jc/resource/buildPlan`,
    method: "post",
    params: {
      resId,
    },
    timeout: 120000,
  });
};
export const getResProjects = (resId) => {
  return request({
    url: `/api/jc/resource/getResProjects`,
    method: "get",
    params: {
      resId,
    },
    timeout: 120000,
  });
};
export const getRules = (resId) => {
  return request({
    url: `/api/jc/resource/getRules`,
    method: "get",
    params: {
      resId,
    },
    timeout: 120000,
  });
};

